// extracted by mini-css-extract-plugin
export default {"KeywordsRemaining":"KeywordsRemaining_KeywordsRemaining__JuTyz","detail":"KeywordsRemaining_detail__d1NS1"};